import axios from '@/plugins/axios'

function store(data) {
  return axios.post('/service-task-types', data)
    .then(response => response.data)
}
function update(data, id) {
  return axios.patch(`/service-task-types/${id}`, data)
    .then(response => response.data)
}

export default {
  save: function (data, id) {
    return id ? update(data, id) : store(data)
  },
  updateOrder: function (data) {
    return axios.post('/service-task-types/order', data)
      .then(response => response.data)
  },
  fetch: function (params) {
    return axios.get('/service-task-types', { params: params })
      .then(response => response.data)
  },
  destroy: function (id) {
    return axios.delete(`/service-task-types/${id}`)
  }
}
